import React, { useState } from 'react';
import { X, Heart, CheckCircle2 } from 'lucide-react';
import { Button } from './Button';
interface RecoveryFeedbackSheetProps {
  onSubmit: (feedback: string) => void;
  onSkip: () => void;
  onClose: () => void;
  preselectedOption?: string;
  showSuccess?: boolean;
}
export function RecoveryFeedbackSheet({
  onSubmit,
  onSkip,
  onClose,
  preselectedOption,
  showSuccess = false
}: RecoveryFeedbackSheetProps) {
  const [selectedOption, setSelectedOption] = useState<string | null>(preselectedOption || null);
  const [isSuccess, setIsSuccess] = useState(showSuccess);
  const options = [{
    value: 'fully_recovered',
    label: 'Fully recovered'
  }, {
    value: 'mostly_recovered',
    label: 'Mostly recovered'
  }, {
    value: 'somewhat_fatigued',
    label: 'Somewhat fatigued'
  }, {
    value: 'very_fatigued',
    label: 'Very fatigued'
  }];
  const handleSubmit = () => {
    if (selectedOption) {
      onSubmit(selectedOption);
      setIsSuccess(true);
      setTimeout(() => {
        onClose();
      }, 1500);
    }
  };
  if (isSuccess) {
    return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-end animate-in fade-in duration-200" onClick={onClose} data-id="element-311">
        <div className="bg-white w-full rounded-t-[2.5rem] p-6 pb-8 shadow-2xl animate-in slide-in-from-bottom-full duration-300 relative" onClick={e => e.stopPropagation()} data-id="element-312">
          <button onClick={onClose} className="absolute top-5 right-5 p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-313">
            <X size={20} data-id="element-314" />
          </button>
          <div className="flex flex-col items-center justify-center py-8" data-id="element-315">
            <div className="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mb-4" data-id="element-316">
              <CheckCircle2 size={32} data-id="element-317" />
            </div>
            <h2 className="text-xl font-extrabold text-slate-800 mb-2" data-id="element-318">
              Thank you
            </h2>
            <p className="text-sm font-medium text-slate-500 text-center" data-id="element-319">
              Your feedback has been saved.
            </p>
          </div>
        </div>
      </div>;
  }
  return <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-sm z-50 flex items-end animate-in fade-in duration-200" data-id="element-320">
      <div className="bg-white w-full rounded-t-[2.5rem] p-6 pb-8 shadow-2xl animate-in slide-in-from-bottom-full duration-300" data-id="element-321">
        <div className="flex items-center justify-between mb-6" data-id="element-322">
          <div className="flex items-center gap-3" data-id="element-323">
            <div className="w-10 h-10 bg-emerald-50 text-emerald-500 rounded-full flex items-center justify-center" data-id="element-324">
              <Heart size={20} data-id="element-325" />
            </div>
            <h2 className="text-xl font-extrabold text-slate-800" data-id="element-326">
              How recovered do you feel today?
            </h2>
          </div>
          <button onClick={onClose} className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-full transition-colors" data-id="element-327">
            <X size={24} data-id="element-328" />
          </button>
        </div>

        <div className="bg-slate-50 rounded-2xl p-4 mb-6 border border-slate-100 flex items-center gap-4" data-id="element-329">
          <div className="w-12 h-12 rounded-2xl overflow-hidden border-2 border-white shadow-sm bg-stone-200 shrink-0" data-id="element-330">
            <video autoPlay loop muted playsInline className="w-full h-full object-cover" src="Recovery Feedback form 1.mp4" data-id="element-331" />
          </div>
          <div data-id="element-332">
            <h3 className="font-extrabold text-slate-800 text-sm mb-0.5" data-id="element-333">
              Full Body
            </h3>
            <p className="text-xs font-medium text-slate-500" data-id="element-334">
              Completed on Wednesday, 25 March
            </p>
          </div>
        </div>

        <p className="text-sm font-medium text-slate-500 mb-6 leading-relaxed" data-id="element-335">
          This helps us adjust your future training more accurately.
        </p>

        <div className="grid grid-cols-2 gap-3 mb-8" data-id="element-336">
          {options.map(option => <button key={option.value} onClick={() => setSelectedOption(option.value)} className={`
                py-4 px-4 rounded-2xl font-bold text-center transition-all duration-200
                border-2
                ${selectedOption === option.value ? 'bg-emerald-50/50 border-emerald-500 text-emerald-700 shadow-sm scale-105' : 'bg-white border-slate-100 text-slate-700 hover:border-slate-200 hover:bg-slate-50'}
              `} data-id="element-337">
              {option.label}
            </button>)}
        </div>

        <div className="space-y-3" data-id="element-338">
          <Button variant="primary" fullWidth onClick={handleSubmit} disabled={!selectedOption} data-id="element-339">
            Submit
          </Button>
          <button onClick={onSkip} className="w-full text-sm font-bold text-slate-500 hover:text-slate-700 transition-colors py-2" data-id="element-340">
            Skip for now
          </button>
        </div>
      </div>
    </div>;
}